import { useOnPressButtons } from '../../hooks/useOnPressButtons'
import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'

import logoImg from '../../assets/logo.png'
import darkBg from '../../assets/page-dark-bg.png'

const titles = [
  'Aspect Kit with a continuous glucose monitor sent to you every two weeks',
  'Two 45-minute consultations with your coach every month',
  'Smart watch integration for additional tracking',
  'At home clinical testing (blood, urine, etc) as needed',
]

const FooterPage = () => {
  const { isSalesPart } = useSelectReportData()
  const { handlePressButtonIndex } = useOnPressButtons()

  return (
    <div>
      <div style={{ padding: '30px 20px 30px 20px' }}>
        <p className={'title-bold-2'}>Thank you</p>
        <p className={'description-sub'}>
          You've learned a lot about your body in these 21 days. Nevertheless, there is still a great deal of room for experimentation and further improvement. So we are always ready to continue our
          adventure with you!
        </p>
      </div>
      <div
        className={'bg-image-config'}
        style={{ backgroundImage: `url(${darkBg})`, padding: '25px 25px 0 25px', borderRadius: '20px 20px 0 0' }}
      >
        {isSalesPart && (
          <>
            <p
              className={'rainbow-text'}
              style={{ fontWeight: '700', fontSize: '1.2rem', textAlign: 'center' }}
            >
              Continued Care Monthly Plan
            </p>
            {titles.map((title, i) => {
              return (
                <div
                  className={'row'}
                  key={i}
                  style={{ alignItems: 'flex-start' }}
                >
                  <div className={'num-dot-item-inverted'}>&#10004;</div>
                  <p
                    style={{ paddingLeft: 20, marginTop: -5, marginBottom: 28 }}
                    className={'text-line inverted-text'}
                  >
                    {title}
                  </p>
                </div>
              )
            })}
            <button
              onClick={handlePressButtonIndex(3)}
              className={'button-rainbow'}
            >
              Sign up today
            </button>
          </>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: 120,
          }}
        >
          <a
            target={'_blank'}
            href={'https://aspect-health.com'}
          >
            <img
              alt={'logo'}
              src={logoImg}
              style={{ width: 120, height: 15, objectFit: 'contain' }}
            />
          </a>
        </div>
      </div>
    </div>
  )
}

export default FooterPage
